import { BackButton } from "../../common/BackButton";
import { useBackNavigation } from "../../../hooks/layout/use-back-navigation/useBackNavigation";
import { useBackButton } from "../../hooks/useBackButton";

export function HeaderBackButton() {
  const backButton = useBackButton();
  const { performBackNavigation } = useBackNavigation(backButton);

  if (!backButton) {
    return <></>;
  } else {
    return <BackButton onClick={performBackNavigation}>Indietro</BackButton>;
  }
}
